module.exports = __webpack_public_path__ + "media/images/emblems/Meltingen-blason-dc0c80b799dda0b437c45eeb20d4aeea.png";